import { Filter } from "../../../types/filter";

import {
  Prefix,
  getNonEmptyUniqueSortedOptions,
  handlePrefix,
  isActiveFilter,
  stringOptionFactory,
} from "../utils";

export type ConsigneeCityQueryParam = "consigneeCity";
export type SomethingWithConsigneeCity = {
  consignee?: {
    city?: string;
  } | null;
  delivery?: {
    city?: string;
  } | null;
};

export const getDeliveryCityFilter = (
  data: SomethingWithConsigneeCity[],
  prefix?: Prefix
): Filter => ({
  label: "Delivery City",
  queryParam: handlePrefix("consigneeCity", prefix),
  options: getNonEmptyUniqueSortedOptions(
    data.map((d) => stringOptionFactory(d.delivery?.city))
  ),
});

export const filterConsigneeCity = <T extends SomethingWithConsigneeCity>(
  data: T[],
  filters?: string[]
): T[] =>
  isActiveFilter(filters)
    ? data.filter(({ delivery }) => filters.includes(delivery?.city || ""))
    : data;
